/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupporterRankUpNotificationActionData
 */
export interface SupporterRankUpNotificationActionData {
    /**
     * 
     * @type {number}
     * @memberof SupporterRankUpNotificationActionData
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof SupporterRankUpNotificationActionData
     */
    senderUserId: string;
    /**
     * 
     * @type {string}
     * @memberof SupporterRankUpNotificationActionData
     */
    receiverUserId: string;
}

/**
 * Check if a given object implements the SupporterRankUpNotificationActionData interface.
 */
export function instanceOfSupporterRankUpNotificationActionData(value: object): value is SupporterRankUpNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "rank" in value && value["rank"] !== undefined;
    isInstance = isInstance && "senderUserId" in value && value["senderUserId"] !== undefined;
    isInstance = isInstance && "receiverUserId" in value && value["receiverUserId"] !== undefined;

    return isInstance;
}

export function SupporterRankUpNotificationActionDataFromJSON(json: any): SupporterRankUpNotificationActionData {
    return SupporterRankUpNotificationActionDataFromJSONTyped(json, false);
}

export function SupporterRankUpNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupporterRankUpNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rank': json['rank'],
        'senderUserId': json['sender_user_id'],
        'receiverUserId': json['receiver_user_id'],
    };
}

export function SupporterRankUpNotificationActionDataToJSON(value?: SupporterRankUpNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rank': value.rank,
        'sender_user_id': value.senderUserId,
        'receiver_user_id': value.receiverUserId,
    };
}

